import { ROUTES } from '@shared/utils';
import type { StatusNotificationType } from '../../StatusNotification/types';
import type { RenewalErrorCode } from '../types';

type RenewalErrorLinkVariant = 'chevron' | 'description';

type RenewalErrorLink = {
  href: string;
  variant: RenewalErrorLinkVariant;
  tracking?: {
    name: string;
  };
};

type RenewalErrorConfig = {
  translationKey: RenewalErrorCode;
  type: StatusNotificationType;
  link?: RenewalErrorLink;
  tracking: {
    type: string;
    message: string;
  };
};

const SPEND_LIMITS_HELP_URL = ROUTES.HELP_CENTRE.BASE_URL + 'faqs/account/1773335744033/';

const renewalErrorConfig = {
  BET_LIMIT: {
    translationKey: 'BET_LIMIT',
    type: 'info',
    link: { href: ROUTES.MY_ACCOUNT.SAFER_GAMBLING, variant: 'chevron' },
    tracking: {
      type: 'Stake limit',
      message: 'Limit Reached',
    },
  },
  NET_DEPOSIT_LIMIT: {
    translationKey: 'NET_DEPOSIT_LIMIT',
    type: 'info',
    link: { href: SPEND_LIMITS_HELP_URL, variant: 'description', tracking: { name: 'Spend Limits' } },
    tracking: {
      type: 'Spend limit',
      message: 'Limit Reached',
    },
  },
  REGULATORY_NET_DEPOSITS_LIMITS: {
    translationKey: 'REGULATORY_NET_DEPOSITS_LIMITS',
    type: 'info',
    link: { href: SPEND_LIMITS_HELP_URL, variant: 'description', tracking: { name: 'Spend Limits' } },
    tracking: {
      type: 'Spend limit',
      message: 'Limit Reached',
    },
  },
  DEPOSIT_LIMIT: {
    translationKey: 'DEPOSIT_LIMIT',
    type: 'info',
    link: { href: ROUTES.MY_ACCOUNT.SAFER_GAMBLING, variant: 'chevron' },
    tracking: {
      type: 'Deposit limit',
      message: 'Limit Reached',
    },
  },
  GENERIC_LIMIT_ERROR: {
    translationKey: 'GENERIC_LIMIT_ERROR',
    type: 'warning',
    tracking: {
      type: 'Auto Renewal',
      message: 'On Hold',
    },
  },
  GENERIC: {
    translationKey: 'GENERIC',
    type: 'warning',
    tracking: {
      type: 'Auto Renewal',
      message: 'On Hold',
    },
  },
  NO_PAYMENT_METHOD: {
    translationKey: 'NO_PAYMENT_METHOD',
    type: 'warning',
    tracking: {
      type: 'Payments',
      message: 'Missing Method',
    },
  },
  PAYMENT_METHOD_EXPIRED: {
    translationKey: 'PAYMENT_METHOD_EXPIRED',
    type: 'warning',
    tracking: {
      type: 'Payments',
      message: 'Card Expired',
    },
  },
} satisfies Record<RenewalErrorCode, RenewalErrorConfig>;

function getRenewalErrorConfig(errorCode: string): RenewalErrorConfig | undefined {
  return renewalErrorConfig[errorCode as RenewalErrorCode];
}

export { getRenewalErrorConfig, renewalErrorConfig, SPEND_LIMITS_HELP_URL };
export type { RenewalErrorConfig, RenewalErrorLink, RenewalErrorLinkVariant };
